import api from '@/libs/axiosInstance';
import type { ApiResponse, ProgramWithStats } from '@fluenceur/types';
import { useQuery, type QueryClient } from '@tanstack/react-query';

export const brandSpaceProgramOptionsQueryPrefix = ['brand-space', 'program-options'] as const;
export const brandSpaceProgramOptionsQueryKey = (brandId: string) =>
  [...brandSpaceProgramOptionsQueryPrefix, brandId] as const;

export function invalidateBrandSpaceProgramOptions(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: brandSpaceProgramOptionsQueryPrefix });
}

async function fetchBrandSpaceProgramOptions(signal: AbortSignal): Promise<ProgramWithStats[]> {
  const response = await api.get<ApiResponse<ProgramWithStats[]>>('/dashboard/programs', {
    signal,
  });
  if (response.data.success === false || !response.data.data) {
    throw new Error(response.data.message ?? 'Failed to fetch Brand Space program options');
  }
  return response.data.data;
}

export function useBrandSpaceProgramOptionsQuery(brandId: string | null | undefined) {
  return useQuery<ProgramWithStats[], Error>({
    queryKey: brandSpaceProgramOptionsQueryKey(brandId ?? ''),
    queryFn: ({ signal }) => fetchBrandSpaceProgramOptions(signal),
    enabled: Boolean(brandId),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
